import React from 'react';
import { kmToMiles } from '../../utils/distance';

const statusLabel = (status) => {
  if (status === 'Least Concern') return { text: 'Least Concern', bg: 'bg-secondary-container/20 text-secondary border-secondary/20' };
  if (status === 'Near Threatened') return { text: 'Near Threatened', bg: 'bg-primary/20 text-primary border-primary/20' };
  if (status === 'Vulnerable') return { text: 'Vulnerable', bg: 'bg-primary/20 text-primary border-primary/20' };
  if (status === 'Endangered') return { text: 'Endangered', bg: 'bg-error/20 text-error border-error/20' };
  if (status === 'Critically Endangered') return { text: 'Critically Endangered', bg: 'bg-error/20 text-error border-error/20' };
  return { text: status, bg: 'bg-surface-variant text-on-surface-variant' };
};

const SpeciesHero = ({ species }) => {
  const badge = statusLabel(species.status);

  return (
    <header className="relative h-[70vh] min-h-[500px] max-h-[870px] w-full overflow-hidden">
      {species.image && (
        <img
          alt={species.name}
          className="absolute inset-0 w-full h-full object-cover object-center"
          src={`${species.image}&w=1920&q=80`}
        />
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-surface via-surface/50 to-surface/20"></div>
      <div className="absolute bottom-0 left-0 p-16 max-w-4xl">
        <div className="flex items-center gap-4 mb-6">
          <span className={`px-4 py-1 rounded-full font-label text-xs uppercase tracking-widest border ${badge.bg}`}>
            {badge.text}
          </span>
          <span className="text-primary font-label text-xs uppercase tracking-widest">
            {species.category}
          </span>
        </div>
        <h1 className="font-headline text-7xl md:text-8xl text-on-surface tracking-tighter mb-4 italic">
          {species.scientificName}
        </h1>
        <p className="font-headline text-3xl text-primary-fixed-dim opacity-90">
          The {species.name}
        </p>
        <div className="mt-12 flex gap-12 border-l border-white/10 pl-8">
          <div>
            <p className="font-label text-xs text-slate-500 uppercase tracking-widest mb-1">Migration Distance</p>
            <p className="font-headline text-4xl text-on-surface">{kmToMiles(species.distance)}</p>
          </div>
          <div>
            <p className="font-label text-xs text-slate-500 uppercase tracking-widest mb-1">Departs</p>
            <p className="font-headline text-4xl text-on-surface">{species.seasons.depart}</p>
          </div>
        </div>
      </div>
    </header>
  );
};

export default SpeciesHero;
